import React, { useEffect, useState } from "react";
import ModalLoadingMessage from "../../../components/modals/ModalLoadingMessage";
import { Button, CircularProgress } from "@mui/material";
import { postData } from "../../../components/utilities/UtilityFunctions";
import { setSessionStorage } from "../../../components/layout/cookies/CookieFunctions";
import { postNotification } from "../../../components/utilities/Notifications";
import { loadStripeAsync } from "./utils";

export default function SubscriptionSessionCheckout(props) {
  const {
    priceId,
    gameStoreId,
    userId,
    affiliate,
    couponCode,
    coupon,
    authContext,
    setConfirmOk
  } = props;

  const [options, setOptions] = useState(null);
  const [message, setMessage] = useState(false);

  return (
    <>
      {message && (
        <ModalLoadingMessage message={message} open={Boolean(message)} />
      )}
      {!options ? (
        <Button
          fullWidth
          color="success"
          variant="contained"
          onClick={async () => {
            const go = async () => {
              try {
                setMessage("Processing...");
                setConfirmOk(true);

                const queryParams = {
                  priceId: priceId,
                  ui_mode: "embedded",
                  return_url: `${window.location.protocol}//${window.location.host}/subscription/session-status`
                };

                if (gameStoreId) queryParams.gameStoreId = gameStoreId;
                if (userId) queryParams.userId = userId;
                if (affiliate) queryParams.affiliate = affiliate;
                if (couponCode) queryParams.couponCode = couponCode;

                const apiSession = await postData(
                  "/stripe/subscriptionSession",
                  queryParams
                );

                if (apiSession?.client_secret) {
                  setSessionStorage(
                    "stripe_session",
                    JSON.stringify({
                      id: apiSession.id,
                      gameStoreId: gameStoreId || ""
                    })
                  );

                  setOptions({
                    clientSecret: apiSession.client_secret
                  });
                } else {
                  throw new Error(
                    "Transaction failed to initiate. Please try again later."
                  );
                }
              } catch (err) {
                postNotification("error", err);
                setConfirmOk(false);
              } finally {
                setMessage(null);
              }
            };

            go();
          }}
          disabled={
            couponCode === "TACOMA25" &&
            coupon &&
            !authContext?.authState?.identity?.hasMyWarhammer
          }
        >
          Confirm
        </Button>
      ) : (
        <div id="checkout">
          <DynamicEmbeddedCheckout options={options} />
        </div>
      )}
    </>
  );
}

function DynamicEmbeddedCheckout({ options, stripe }) {
  const [EmbeddedComponents, setEmbeddedComponents] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const [stripeLoading, setStripeLoading] = useState(false);

  useEffect(() => {
    if (!stripePromise && !stripeLoading) {
      setStripeLoading(true);
      loadStripeAsync()
        .then((stripeInstance) => {
          setStripePromise(stripeInstance);
          setStripeLoading(false);
        })
        .catch((error) => {
          console.error("Failed to load Stripe:", error);
          setStripeLoading(false);
        });
    }
  }, [stripePromise, stripeLoading]);

  useEffect(() => {
    const loadEmbeddedComponents = async () => {
      try {
        const stripeReact = await import("@stripe/react-stripe-js");
        setEmbeddedComponents({
          EmbeddedCheckoutProvider: stripeReact.EmbeddedCheckoutProvider,
          EmbeddedCheckout: stripeReact.EmbeddedCheckout
        });
      } catch (error) {
        console.error("Failed to load Stripe Embedded components:", error);
      }
    };
    loadEmbeddedComponents();
  }, []);

  if (!EmbeddedComponents || !stripePromise) {
    return <CircularProgress />;
  }
  // I'm aware that React.createElement is outdated but seems to be only working method I've found w/ dynamic imports
  return React.createElement(
    EmbeddedComponents.EmbeddedCheckoutProvider,
    { stripe: stripePromise, options },
    React.createElement(EmbeddedComponents.EmbeddedCheckout)
  );
}
